import React from 'react';
import { CompareSlides, SEO } from '../../components';
import { graphql } from 'gatsby';
import './process.css';

function ComparePage() {
  return (
    <main id='compare-page'>
      <CompareSlides />
    </main>
  );
}

export const Head = ({ data, location }) => {
  const query = data.siteDataJson;
  return (
    <SEO
      location={location}
      origin={query.origin}
      title={`Comparison Hair Removal Techniques Including Laser | Milan Laser in ${query.name}, ${query.stateAbbrev}`}
      description='Ditch the razors and wax strips! Find out why laser hair removal is the best choice for long-lasting results. Explore our summary page comparing laser hair removal to waxing and shaving. Say hello to smooth skin!'
    />
  );
};

export const query = graphql`
  {
    siteDataJson {
      name
      stateAbbrev
      origin
    }
  }
`;

export default ComparePage;
